<template>
  <p class="stock-match-price">
    {{ i18n.n(price, 'currency') }}
    <span
      v-if="difference"
      class="stock-match-price__difference"
      :class="{ 'stock-match-price__difference--cheaper': difference < 0 }"
      >({{ difference < 0 ? '−' : '+' }}&nbsp;{{ i18n.n(Math.abs(difference), 'currency') }})</span
    >
  </p>
</template>

<script>
export default {
  props: {
    price: {
      type: Number,
      required: true,
    },
    difference: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
}
</script>

<style lang="scss" scoped>
.stock-match-price {
  margin: 0;
  font-size: var(--ds-font-size-lg);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.stock-match-price__difference {
  font-size: var(--ds-font-size-xs);
  font-weight: 400;
  color: var(--ds-color-text-muted);

  &--cheaper {
    color: var(--ds-color-success);
  }
}
</style>
